<template>
  <!-- 编辑修改乘机人 修改出行人-->
  <van-popup
    v-model="isShow"
    :close-on-click-overlay="false"
    :get-container="getContainer"
    :lock-scroll="true"
    class="full-height full-width"
    position="right"
  >
    <div class="full-height">
      <ld-header @click-left="toggle">
        {{ $t('C184', '修改出行人') }}
      </ld-header>
      <div>
        <van-cell-group>
          <van-field
            v-model="psgTypeName"
            :label="$t('C114','乘客类型')"
            :readonly="true"
            input-align="left"
            is-link
            @click="showPsgType=!showPsgType"
          />
          <van-action-sheet
            v-model="showPsgType"
            :actions="[
              {key:1,name:'成人'},
              {key:2,name:'儿童'}
            ]"
            @select="psgTypeSelect"
          />
          <van-field
            v-model="name"
            :label="$t('D007','姓名')"
            :placeholder="$t('D007','姓名')"
            :readonly="canedit(emp)"
            input-align="left"
          />
          <van-field
            v-model="emp.cardName"
            :label="$t('D003','证件类型')"
            :readonly="true"
            input-align="left"
          />
          <van-field
            v-model="emp.cardNumber"
            :label="$t('D008','证件号码')"
            :placeholder="$t('D008','证件号码')"
            type="text"
          />
          <van-field
            v-model="emp.born"
            :label="$t('D013','出生日期')"
            :readonly="true"
            input-align="left"
            is-link
            @click="showDate=true"
          />
          <van-popup
            v-model="showDate"
            :lock-scroll="true"
            position="bottom"
          >
            <van-datetime-picker
              v-model="currentDate"
              :max-date="maxDate"
              :min-date="minDate"
              type="date"
              @cancel="showDate=false"
              @confirm="getBorn"
            />
          </van-popup>
          <van-field
            v-model="emp.phoneNumber"
            :label="$t('F008','手机号')"
            :placeholder="$t('F008','手机号')"
            clearable
            max="13"
            type="number"
          />
        </van-cell-group>
        <div class="pad">
          <ld-button
            main
            size="lg"
            @click.native="comple"
          >
            {{ $t('B006', '确定') }}
          </ld-button>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import ldButton from 'Common/ldButton'
import {ActionSheet, Cell, CellGroup, DatetimePicker, Field, Popup} from 'vant'
import {formatDate} from 'Utils/dateUtil'
import {getName} from 'Utils/publicFun'
import {mapGetters} from 'vuex'

export default {
  name: 'LdEditPsg',
  components: {
    ldButton,
    [Popup.name]: Popup,
    [ActionSheet.name]: ActionSheet,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker
  },
  props: {
    psgInfo: {
      type: Object,
      default: function () {
        return {}
      }
    },
    element: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isShow: false,
      showPsgType: false,
      showDate: false,
      psgTypeName: '',
      currentDate: new Date(),
      minDate: new Date('1940-01-01'),
      maxDate: new Date(),
      emp: {},
      name: ''
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo'
    })
  },
  methods: {
    canedit(psg) {
      return !((this.userInfo.vipCorp.tripType == 1 && this.userInfo.vipCorp.bookStyle == 2) || psg.empId || psg.conempId)
    },
    psgTypeSelect(item) {
      //乘机人类型
      this.emp.psgType = item.key
      this.psgTypeName = item.name
      this.showPsgType = false
    },
    getBorn(item) {
      //出生日期
      this.showDate = false
      this.emp.born = formatDate(item).date
    },
    comple() {
      this.getCardNum()
      this.$emit('selected', this.emp)
      this.toggle()
    },
    getCardNum() {
      this.emp.passport = this.emp.cardNumber
    },
    cardType() {
      this.emp.cardType = 2
      this.emp.cardNumber = this.emp.passport
      this.emp.cardName = this.$t('D005', '护照')
    },
    init() {
      this.emp = this.psgInfo
      if (this.emp.psgType == 1) {
        this.psgTypeName = '成人'
      } else if (this.emp.psgType == 2) {
        this.psgTypeName = this.$t('C116', '儿童')
      } else {
        this.psgTypeName = '成人'
      }
      this.name = getName(this.emp)
      this.cardType()
    },
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getContainer() {
      if (this.element) {
        return document.querySelector(this.element)
      }
      return ''
    },
    toggle() {
      this.isShow = !this.isShow
    }
  },
  watch: {
    psgInfo() {
      this.init()
    }
  }
}
</script>

<style lang="less" scoped>
.pad {
  padding: 20px;
}
</style>
